import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import BaseModal from './BaseModal';
import { inputTypes } from '../../utils/inputTypes';
import ModalForm from './ModalForm';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { createNew, editUser } from '../../actions/userActions'
import { showSnackbar, closeSnackbar } from "../../actions/snackbarActions";
import ApiService from '../../services/api';
import { loadCompaniesAsync } from "../../actions/companyActions";

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
});

class UserModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      formFields: []
    }
    this.apiService = new ApiService();
  }

  async componentDidMount() {
    const companies = await this.props.loadCompaniesAsync();
    const roles = [
      "user",
      "admin",
      "helpdesk",
      "viewer"
    ];

    // Array of inputs that dynamically build
    // up the editor form.
    let formFields = [
      {
        id: "firstName",
        name: "firstName",
        label: "First Name",
        type: inputTypes.textField
      },
      {
         id: "lastName",
         name: "lastName",
         label: "Last Name",
         type: inputTypes.textField
       },
       {
         id: "email",
         name: "email",
         label: "Email",
         type: inputTypes.textField,
         disabled: () => this.props.isEdit
       },
       {
         id: "role",
         name: "role",
         label: "Role",
         type: inputTypes.select,
         options: roles,
         disabled: () => this.props.isEdit
       },
      {
        id: "companyId",
        name: "companyId",
        label: "Company",
        type: inputTypes.select,
        options: companies,
        disabled: () => this.props.isEdit
      }
    ];

    this.setState({
      formFields: formFields
    })

  }

  // This function is called by the child component
  // (<BaseModal>) during its own submit function
  onSubmit = async (values) => {
    // Different action needs to be fired, depending on
    // whether creating new company or editing one.
    if (this.props.isEdit && this.props.selectedUser) {
      const id = this.props.selectedUser.id;
      const editedUser = { ...values, id };
      await this.props.editUser(editedUser);
      this.props.showSnackbar("User edited");

    } else {
      await this.props.createNew(values);
      this.props.showSnackbar("New user created");
    }
  }


  // Validation schema can be difficult to build dynamically
  // in the child component. For easiness, it's created here
  // and then passed down as prop
  validationSchema = Yup.object().shape();

  render() {
    const {isOpen, handleClose, isEdit, selectedUser } = this.props;

    return (
      <BaseModal isEdit={isEdit} modalType="User"  onSubmit={this.onSubmit} isOpen={isOpen} handleClose={handleClose}>
        <ModalForm validationSchema={this.validationSchema} initialValues={selectedUser} formFields={this.state.formFields} handleCancel={handleClose}>
        </ModalForm>
      </BaseModal>
    )
  }
}
export default
  compose(
    withStyles(styles),
    connect(null, { createNew, editUser, showSnackbar, closeSnackbar, loadCompaniesAsync })
  )(UserModal);



// WEBPACK FOOTER //
// ./src/components/Modals/UserModal.js